import { Grid, Text } from "designSystem/index";
import React from "react";

export default () => (
	<Grid
		container
		direction="column"
		spacing={3}
		style={{ textAlign: "left" }}
	>
		<Grid item>
			<Text text="h1: The quick brown fox jumps over the lazy dog 0123456789!" variant="h1" />
		</Grid>
		<Grid item>
			<Text text="h2: The quick brown fox jumps over the lazy dog 0123456789!" variant="h2" />
		</Grid>
		<Grid item>
			<Text text="h3: The quick brown fox jumps over the lazy dog 0123456789!" variant="h3" />
		</Grid>
		<Grid item>
			<Text text="h4: The quick brown fox jumps over the lazy dog 0123456789!" variant="h4" />
		</Grid>
		<Grid item>
			<Text text="h5: The quick brown fox jumps over the lazy dog 0123456789!" variant="h5" />
		</Grid>
		<Grid item>
			<Text text="h6: The quick brown fox jumps over the lazy dog 0123456789!" variant="h6" />
		</Grid>
		<Grid item>
			<Text text="subtitle1: The quick brown fox jumps over the lazy dog 0123456789!" variant="subtitle1" />
		</Grid>
		<Grid item>
			<Text text="subtitle2: The quick brown fox jumps over the lazy dog 0123456789!" variant="subtitle2" />
		</Grid>
		<Grid item>
			<Text text="body1: The quick brown fox jumps over the lazy dog 0123456789!" variant="body1" />
		</Grid>
		<Grid item>
			<Text text="body2: The quick brown fox jumps over the lazy dog 0123456789!" variant="body2" />
		</Grid>
		<Grid item>
			<Text text="button: The quick brown fox jumps over the lazy dog 0123456789!" variant="button" />
		</Grid>
		<Grid item>
			<Text text="caption: The quick brown fox jumps over the lazy dog 0123456789!" variant="caption" />
		</Grid>
		<Grid item>
			<Text text="overline: The quick brown fox jumps over the lazy dog 0123456789!" variant="overline" />
		</Grid>
	</Grid>
);